import { LOAD_ACCOUNT, LOAD_ACCOUNT_DATA, LOAD_ACCOUNT_DATA_FAILURE, GET_ACCOUNTS_REQUEST, GET_ACCOUNTS_SUCCESS, GET_ACCOUNTS_FAILURE, CLEAR_ACCOUNT_REQUEST } from '../actions';

/**
 * Account reducer (some general actions)
 */
function account(state = {
  storeAccount: null,
  isLoadingData: false,
  isGettingAccounts: false,
  accounts: [],
  accountsCount: 0
}, action) {
  switch (action.type) {
    case LOAD_ACCOUNT:
      return {
        ...state,
        isLoadingData: false,
        storeAccount: action.storeAccount
      };
    case LOAD_ACCOUNT_DATA:
      return {
        ...state,
        isLoadingData: true,
        storeAccount: null,
        accountDataLoadError: null
      };
    case LOAD_ACCOUNT_DATA_FAILURE:
      return {
        ...state,
        isLoadingData: false,
        accountDataLoadError: action.accountDataLoadError
      };
    case CLEAR_ACCOUNT_REQUEST:
      return {
        ...state,
        isLoadingData: false,
        storeAccount: null
      };
    case GET_ACCOUNTS_REQUEST:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts
      };
    case GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts,
        accounts: action.accounts,
        accountsCount: action.accountsCount
      };
    case GET_ACCOUNTS_FAILURE:
      return {
        ...state,
        isGettingAccounts: action.isGettingAccounts
      };
    default:
      return state;
  }
}

export default account;
